import { jsx, jsxs } from "react/jsx-runtime";
import { Box, Columns, Column } from "braid-design-system";
import { tabularNums } from "./OrderTableRow.css.mjs";
const OrderTableRow = ({ left, right }) => /* @__PURE__ */ jsx(Box, { className: tabularNums, children: /* @__PURE__ */ jsxs(Columns, { space: "none", children: [
  /* @__PURE__ */ jsxs(Column, { width: "3/5", children: [
    left,
    " "
  ] }),
  /* @__PURE__ */ jsx(Column, { width: "2/5", children: right })
] }) });
export {
  OrderTableRow
};
